// This icon file is generated automatically.
var PCalendarOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.75 1.88h-2.63v-1A.13.13 0 0010 .74h-.88A.13.13 0 009 .88v1H5v-1a.13.13 0 00-.13-.13H4a.13.13 0 00-.13.13v1H1.25a.5.5 0 00-.5.5v10.37c0 .28.22.5.5.5h11.5a.5.5 0 00.5-.5V2.37a.5.5 0 00-.5-.5zm-.63 10.25H1.88V6.18h10.25v5.93zm-10.24-7V3h2v.75c0 .07.05.13.12.13h.88c.06 0 .12-.06.12-.13V3h4v.75c0 .07.06.13.13.13H10c.07 0 .13-.06.13-.13V3h2v2.13H1.87z", "fill-rule": "nonzero" } }] }, "name": "p-calendar", "theme": "outlined" };
export default PCalendarOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PCalendarOutlined.js
// module id = 3267
// module chunks = 0